import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationRoofThatchedFireproof: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_1770_6771"
        style={{ maskType: 'alpha' }}
        width="356"
        height="228"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 0h356v228H0V0z"></path>
      </mask>
      <g mask="url(#mask0_1770_6771)">
        <path
          fill={colors.primary[50]}
          d="M337 161c0 88.366-71.634 160-160 160S17 249.366 17 161 88.634 1 177 1s160 71.634 160 160z"
        ></path>
        <path
          fill="#fff"
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M178.302 63.123L107 134.419v91.131h142.599v-91.131l-71.297-71.296z"
        ></path>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M237.333 55.985a7.313 7.313 0 00-7.312-7.312h-12.084a7.311 7.311 0 00-7.312 7.312v14.464l26.734 26.422-.026-40.886zM195.858 155.617h35.648v35.648h-35.648v-35.648z"
        ></path>
        <path
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M195.858 173.444h35.648"
        ></path>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[200]}
          strokeLinejoin="round"
          strokeWidth="4"
          d="M169.124 170.84a17.837 17.837 0 00-10.923-16.782 17.833 17.833 0 00-13.803 0 17.83 17.83 0 00-10.923 16.782v35.648h35.649V170.84z"
        ></path>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[200]}
          strokeWidth="4"
          d="M125.251 208.947a5 5 0 015-5h44.162a5 5 0 015 5v15.927h-54.162v-15.927z"
        ></path>
        <path
          fill={colors.primary[200]}
          fillRule="evenodd"
          d="M163.435 41.474c7.897-8.39 21.232-8.39 29.129 0l85.32 90.655c.836.888.652 2.172-.127 2.871H278l-6.348 11-4.748-7.852-5.229 7.852-5.628-8.067-5.372 8.067-5.628-8.067-5.372 8.067-5.628-8.067-5.372 8.067-5.628-8.067-5.372 8.067-5.628-8.067-5.372 8.067-5.628-8.067-5.372 8.067-5.628-8.067-5.372 8.067-5.628-8.067-5.372 8.067-5.628-8.067-5.372 8.067-5.628-8.067-5.372 8.067-5.628-8.067-5.372 8.067-5.628-8.067-5.372 8.067-5.628-8.067-5.372 8.067-5.628-8.067-5.372 8.067-5.628-8.067L96.675 146l-5.628-8.067L85.675 146 78 135h.242c-.78-.699-.963-1.983-.127-2.871l85.32-90.654z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M192.564 41.474l1.456-1.37-1.456 1.37zm-29.129 0l-1.456-1.37 1.456 1.37zm114.449 90.655l-1.456 1.371 1.456-1.371zm-.127 2.871l-1.336-1.489a2.002 2.002 0 001.336 3.489v-2zm.243 0l1.732.999A2 2 0 00278 133v2zm-6.348 11l-1.711 1.035a2 2 0 003.443-.036l-1.732-.999zm-4.748-7.852l1.711-1.035a2 2 0 00-3.376-.074l1.665 1.109zM261.675 146l-1.64 1.144a2 2 0 003.305-.036L261.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM250.675 146l-1.64 1.144a2 2 0 003.305-.036L250.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM239.675 146l-1.64 1.144a2 2 0 003.305-.036L239.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM228.675 146l-1.64 1.144a2 2 0 003.305-.036L228.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM217.675 146l-1.64 1.144a2 2 0 003.305-.036L217.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM206.675 146l-1.64 1.144a2 2 0 003.305-.036L206.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM195.675 146l-1.64 1.144a2 2 0 003.305-.036L195.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM184.675 146l-1.64 1.144a2 2 0 003.305-.036L184.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM173.675 146l-1.64 1.144a2 2 0 003.305-.036L173.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM162.675 146l-1.64 1.144a2 2 0 003.305-.036L162.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM151.675 146l-1.64 1.144a2 2 0 003.305-.036L151.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM140.675 146l-1.64 1.144a2 2 0 003.305-.036L140.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM129.675 146l-1.64 1.144a2 2 0 003.305-.036L129.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM118.675 146l-1.64 1.144a2 2 0 003.305-.036L118.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM107.675 146l-1.64 1.144a2 2 0 003.305-.036L107.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM96.675 146l-1.64 1.144a2 2 0 003.305-.036L96.675 146zm-5.628-8.067l1.64-1.144a2 2 0 00-3.305.036l1.665 1.108zM85.675 146l-1.64 1.144a2 2 0 003.305-.036L85.675 146zM78 135v-2a2 2 0 00-1.64 3.144L78 135zm.242 0v2a2 2 0 001.336-3.489L78.242 135zm-.127-2.871l1.456 1.371-1.456-1.371zM194.02 40.104c-8.686-9.23-23.355-9.23-32.041 0l2.913 2.741c7.107-7.551 19.108-7.551 26.215 0l2.913-2.741zm85.321 90.654L194.02 40.104l-2.913 2.741 85.321 90.655 2.913-2.742zm-.248 5.73c1.521-1.365 1.937-3.935.248-5.73l-2.913 2.742c.009.009.012.014.011.014l-.004-.009a.325.325 0 00-.003-.014v-.005l-.001.006-.004.011-.005.008h-.001l2.672 2.977zm-1.336.512H278v-4h-.243v4zm-1.489-3l-6.348 11 3.464 1.999 6.348-11-3.464-1.999zm-2.905 10.965l-4.748-7.852-3.423 2.07 4.749 7.852 3.422-2.07zm-10.023 2.143l5.228-7.852-3.329-2.217-5.228 7.852 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.933-8.03l5.628 8.066 3.281-2.289-5.629-8.066-3.28 2.289zm-2.067 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-8.934-8.03l5.63 8.066 3.28-2.289-5.63-8.066-3.28 2.289zm-2.066 8.03l5.371-8.066-3.329-2.217-5.371 8.066 3.329 2.217zm-10.98-10.964l7.675 11 3.28-2.289-7.675-11-3.28 2.289zM78.242 133H78v4h.242v-4zm-1.584-2.242c-1.688 1.795-1.273 4.365.248 5.73l2.672-2.977c.001.001 0 .001 0 0a.39.39 0 00-.005-.008.057.057 0 01-.005-.017v.005a.072.072 0 01-.004.014l-.004.009s.002-.005.011-.014l-2.912-2.742zm85.321-90.654l-85.32 90.654 2.912 2.742 85.321-90.655-2.913-2.741z"
        ></path>
        <path
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M192 61l24 28M231.5 103l19 21M199.5 104l4.5 20.5M167 95.5L156.5 123M150 90.5l-11.5 21M134 90l-23.5 29.5"
        ></path>
        <g filter="url(#filter0_dd_1770_6771)">
          <circle cx="242" cy="120" r="55" fill="#fff"></circle>
          <circle
            cx="242"
            cy="120"
            r="53"
            stroke={colors.primary[500]}
            strokeWidth="4"
          ></circle>
        </g>
        <path
          fill={colors.primary[200]}
          stroke={colors.primary[500]}
          strokeLinejoin="round"
          strokeWidth="4"
          d="M225.843 104.645a1.264 1.264 0 011.29-.021 1.273 1.273 0 01.643 1.12 17.204 17.204 0 003.315 10.829 1.263 1.263 0 001.674.306c2.053-1.281 6.808-5.306 9.183-15.996a42.757 42.757 0 00.609-16.404 1.259 1.259 0 01.526-1.255 1.261 1.261 0 011.36-.048 52.048 52.048 0 0125.437 44.236c.362 15.857-12.163 29.419-28.023 29.368A27.941 27.941 0 01214 128.835c.003-11.501 5.203-19.877 11.843-24.19z"
        ></path>
        <path
          fill="#fff"
          stroke={colors.primary[500]}
          strokeLinejoin="round"
          strokeWidth="4"
          d="M250.736 123.666a1.278 1.278 0 00-1.262.157 1.266 1.266 0 00-.494 1.172c.142.958.197 1.927.163 2.896-.22 6.332-4.172 10.201-8.605 10.047a6.961 6.961 0 01-6.236-4.161 1.27 1.27 0 00-2.413.308 13.972 13.972 0 0012.438 16.477 13.958 13.958 0 0010.701-3.577 13.976 13.976 0 004.569-10.317 13.967 13.967 0 00-8.861-13.002z"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_dd_1770_6771"
          width="142"
          height="142"
          x="171"
          y="57"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="8"></feOffset>
          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1770_6771"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.04 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_1770_6771"
            result="effect2_dropShadow_1770_6771"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1770_6771"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
};

export default IllustrationRoofThatchedFireproof;
